// Read-only, print-friendly rendering of a permit schema + its answers.
export function SchemaPrint({ schema, data = {} }) {
  return (
    <div className="space-y-5">
      {schema.intro && <p className="text-[11px] italic text-neutral-600">{schema.intro}</p>}
      {schema.sections.map((section) => (
        <div key={section.id} className="no-break">
          <div className="mb-2 border-b-2 border-brand pb-1 font-heading text-sm font-bold uppercase tracking-wide text-brand">
            {section.title}
          </div>
          {section.note && <p className="mb-2 text-[11px] italic text-neutral-600">{section.note}</p>}
          <div className="space-y-1.5">
            {section.fields.map((f) => (
              <PrintField key={f.key} f={f} value={data[f.key]} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function PrintField({ f, value }) {
  if (f.type === "matrix") {
    const val = value || {};
    return (
      <div className="no-break py-1">
        <div className="mb-1 text-[12px] font-semibold">{f.label}</div>
        <table className="w-full border-collapse text-[11px]">
          <thead>
            <tr>
              <th className="border border-neutral-400 bg-neutral-100 px-2 py-1 text-left">Item</th>
              {f.columns.map((c) => (
                <th key={c} className="w-14 border border-neutral-400 bg-neutral-100 px-1 py-1 text-center">{c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {f.rows.map((r) => (
              <tr key={r.label}>
                <td className="border border-neutral-400 px-2 py-1 align-top">
                  <span className="font-medium">{r.label}</span>
                  {r.desc && <span className="block text-[10px] text-neutral-500">{r.desc}</span>}
                </td>
                {f.columns.map((c) => (
                  <td key={c} className="border border-neutral-400 px-1 py-1 text-center font-bold">
                    {val[r.label] && val[r.label][c] ? "\u2713" : ""}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  if (f.type === "confirm") {
    return (
      <div className="flex items-start gap-2 text-[11px]">
        <span className="mt-0.5 inline-flex h-3.5 w-3.5 items-center justify-center border border-neutral-500 text-[9px] font-bold">
          {value ? "\u2713" : ""}
        </span>
        <span className="leading-snug">{f.label}</span>
      </div>
    );
  }
  if (f.type === "radio") {
    return (
      <div className="flex justify-between gap-3 text-[12px]">
        <span className="font-medium">{f.label}</span>
        <span className="whitespace-nowrap font-bold text-brand">{value || "—"}</span>
      </div>
    );
  }
  // text / textarea / date / time
  return (
    <div className="text-[12px]">
      <span className="font-medium">{f.label}: </span>
      <span className="text-neutral-800">{value || "—"}</span>
    </div>
  );
}
